import React from "react";
import formElements from "./formElements";
import "./styles.css";

const FormFactory = ({
  formElementsTypes,
  onChangeHandler,
  errors,
  resendOtp = null,
  resendOtpTime = null,
  className,
  onKeyPress,
}) => {
  const elements = [];
  for (let element in formElementsTypes) {
    const formElement = {
      id: element,
      data: formElementsTypes[element],
    };

    const fields = formElements(
      formElement,
      onChangeHandler,
      errors,
      resendOtp,
      resendOtpTime,
      onKeyPress
    );

    if (!formElementsTypes[element].hiddenField) {
      elements.push(fields);
    }
  }

  return (
    <div className={`sapphire-webapp-form-elements form-elements ${className}`}>
      {elements}
    </div>
  );
};

export default FormFactory;
